/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/inviteUser.config.json";
import { VApplication } from "../../../application";
import { AppNavigatorService } from "../../appNavigatorService";
import notification from "../config/notifications.config.json";
import axios from "axios";

import { useOrgId } from "../provider";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { REINVITE_CREDIT_UNION_USER } from "../graphql";
import moment from "moment-timezone";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

const LoginPageServ = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};

export interface ReInviteUserProps {
  email: string;
  firstName: string;
  lastName: string;
  invite: boolean;
  loginRestAPI: string;
  headers: any;
  termsOfUse: any;
}
export interface IReInviteUserMethods extends IPluginMethodMap {
  getReInviteUser(args: ReInviteUserProps): Promise<any>;
}

export class ReInviteUserService implements IAgentPlugin {
  readonly methods: IReInviteUserMethods;

  constructor() {
    this.methods = {
      getReInviteUser: this.getReInviteUser.bind(this),
    };
  }

  async getReInviteUser(args: ReInviteUserProps) {
    const srv = LoginPageServ();
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const { orgId } = useOrgId();
    console.log(`args in invite user service`, args);
    try {
      if (client) {
        const res = await client.mutate({
          mutation: REINVITE_CREDIT_UNION_USER,
          variables: {
            input: {
              vuid: args,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          console.log(`table data`, res);
          return {
            ...res?.data,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
